import { PROGRAMS_UPDATE } from '../actions/types';
import { ProgramCatalogEntry, ProgramResponse } from '../api/programs.interface';
import { ProgramEditorDraft, ProgramManagementListItem } from '../components/programs/programs.types';

export interface ProgramsState {
    deletingProgramName?: string;
    draftProgram?: ProgramEditorDraft;
    hasUnsavedChanges: boolean;
    hydratingProgramCatalog: boolean;
    items: ProgramManagementListItem[];
    loadingList: boolean;
    loadingProgram: boolean;
    savingProgram: boolean;
    selectedProgramCatalog?: ProgramCatalogEntry;
    selectedProgram?: ProgramResponse;
    selectedProgramName?: string;
    selectedWeek: number;
}

const InitialState: ProgramsState = {
    hasUnsavedChanges: false,
    hydratingProgramCatalog: false,
    items: [],
    loadingList: false,
    loadingProgram: false,
    savingProgram: false,
    selectedWeek: 1,
};

export const ProgramsReducer = (state: ProgramsState = InitialState, action: any) => {
    switch (action.type) {
        case PROGRAMS_UPDATE:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};

export default ProgramsReducer;